import React from 'react';
import PropTypes from 'prop-types';

import {Helmet} from 'react-helmet';
import {injectIntl} from 'react-intl';

import ResetPasswordModal from '../modals/ResetPasswordModal';

@injectIntl
export default class ResetPasswordPage extends React.PureComponent {
  render() {
    const {intl} = this.props;
    const {userId, token} = this.props.params;

    return (
      <React.Fragment>
        <Helmet>
          <title>{intl.formatMessage({id: 'section.auth.password.reset'})}</title>
        </Helmet>

        <div className="page-auth">
          <ResetPasswordModal page userId={userId} token={token}/>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/auth/pages/ResetPasswordPage.js